import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { BaseHttpService } from './base-http.service';
import { RequestAccessCardCancellation, AccessCardCancellationAdd} from '../models';

@Injectable()
export class RequestAccessCardCancellationService extends BaseHttpService<RequestAccessCardCancellation> {

  constructor() {
    super('request-access-card-cancellation');
  }

  cancellation(entity: AccessCardCancellationAdd): Observable<RequestAccessCardCancellation> {
    return this.httpClient
      .post(this.uri, JSON.stringify(entity))
      .catch(this.handleError);
  }


  approveByTenant(requestId: number): Observable<RequestAccessCardCancellation> {
    return this.httpClient
      .put(this.uri + `${requestId}/approve-tenant`, {})
      .catch(this.handleError)
  }

  rejectByTenant(requestId: number, comments: string): Observable<RequestAccessCardCancellation> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-tenant`, { comments: comments })
      .catch(this.handleError)
  }

  markAsCompleted(requestId: number, comments: string): Observable<RequestAccessCardCancellation> {
    return this.httpClient
      .put(this.uri + `${requestId}/complete`, { comments: comments })
      .catch(this.handleError)
  }
  

}



// WEBPACK FOOTER //
// ./src/app/core/data/request-access-card-cancellation.service.ts